/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Mise à jour d'un tunnel. Surface d'écriture réelle du back : les taux de commission, parties communes/privatives et nombre de prélèvements ne sont plus modifiables ici.
 * @export
 * @interface UpdateFunnelCommand
 */
export interface UpdateFunnelCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateFunnelCommand
     */
    tunnelId: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateFunnelCommand
     */
    designation: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFunnelCommand
     */
    isActive: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateFunnelCommand
     */
    produitId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateFunnelCommand
     */
    beneficiairePersonneId: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateFunnelCommand
     */
    compteBancaireId: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateFunnelCommand
     */
    ownerId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateFunnelCommand
     */
    fraisResiliation?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFunnelCommand
     */
    isListingActive?: boolean;
    /**
     * Le courtier peut être prélevé à la place du souscripteur (courtier encaisseur)
     * @type {boolean}
     * @memberof UpdateFunnelCommand
     */
    brokerCollectionAllowed?: boolean;
}

/**
 * Check if a given object implements the UpdateFunnelCommand interface.
 */
export function instanceOfUpdateFunnelCommand(value: object): value is UpdateFunnelCommand {
    if (!('tunnelId' in value) || value['tunnelId'] === undefined) return false;
    if (!('designation' in value) || value['designation'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('beneficiairePersonneId' in value) || value['beneficiairePersonneId'] === undefined) return false;
    if (!('compteBancaireId' in value) || value['compteBancaireId'] === undefined) return false;
    return true;
}

export function UpdateFunnelCommandFromJSON(json: any): UpdateFunnelCommand {
    return UpdateFunnelCommandFromJSONTyped(json, false);
}

export function UpdateFunnelCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateFunnelCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'tunnelId': json['tunnelId'],
        'designation': json['designation'],
        'isActive': json['isActive'],
        'produitId': json['produitId'] == null ? undefined : json['produitId'],
        'beneficiairePersonneId': json['beneficiairePersonneId'],
        'compteBancaireId': json['compteBancaireId'],
        'ownerId': json['ownerId'] == null ? undefined : json['ownerId'],
        'fraisResiliation': json['fraisResiliation'] == null ? undefined : json['fraisResiliation'],
        'isListingActive': json['isListingActive'] == null ? undefined : json['isListingActive'],
        'brokerCollectionAllowed': json['brokerCollectionAllowed'] == null ? undefined : json['brokerCollectionAllowed'],
    };
}

export function UpdateFunnelCommandToJSON(json: any): UpdateFunnelCommand {
    return UpdateFunnelCommandToJSONTyped(json, false);
}

export function UpdateFunnelCommandToJSONTyped(value?: UpdateFunnelCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tunnelId': value['tunnelId'],
        'designation': value['designation'],
        'isActive': value['isActive'],
        'produitId': value['produitId'],
        'beneficiairePersonneId': value['beneficiairePersonneId'],
        'compteBancaireId': value['compteBancaireId'],
        'ownerId': value['ownerId'],
        'fraisResiliation': value['fraisResiliation'],
        'isListingActive': value['isListingActive'],
        'brokerCollectionAllowed': value['brokerCollectionAllowed'],
    };
}

